import React from 'react';
import * as PropTypes from 'prop-types';
import cn from 'classnames';
import get from 'lodash/get';

import SimpleAvatar from '../../../common/SimpleAvatar';
import styles from './styles.styl';

function NameWithAvatar({
  avatar,
  name,
  avatarSize,
  metaText,
  noAvatar,
  whiteAvatar,
  className,
}) {
  return (
    <div className={cn(styles.root, className)}>
      {!noAvatar && (
        <SimpleAvatar
          src={get(avatar, 'thumbMin')}
          text={name}
          size={avatarSize}
          white={whiteAvatar}
          bordered
        />
      )}
      <div className={cn(styles.name, { [styles.noAvatar]: noAvatar })}>
        <span className={cn(styles.strong, { [styles.noMeta]: !metaText })}>
          {name}
        </span>
        <span className={styles.meta}>{metaText}</span>
      </div>
    </div>
  );
}

NameWithAvatar.propTypes = {
  avatar: PropTypes.object,
  name: PropTypes.string,
  className: PropTypes.string,
  avatarSize: PropTypes.number,
  metaText: PropTypes.node,
  whiteAvatar: PropTypes.bool,
  noAvatar: PropTypes.bool,
};

NameWithAvatar.defaultProps = {
  avatarSize: 68,
  noAvatar: false,
};

export default NameWithAvatar;



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/NameWithAvatar/index.jsx